import { supabase } from '../lib/supabase';

// Blog Service - All API calls for blog posts

export const blogService = {
    // Get all blog posts
    async getAllPosts() {
        try {
            const { data, error } = await supabase
                .from('blog_posts')
                .select('*')
                .order('created_at', { ascending: false });

            if (error) throw error;
            
            return {
                success: true,
                data: data || []
            };
        } catch (error) {
            console.error('Error fetching posts:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Get single blog post by slug
    async getPostBySlug(slug) {
        try {
            const { data, error } = await supabase
                .from('blog_posts')
                .select('*')
                .eq('slug', slug)
                .single();

            if (error) throw error;

            return {
                success: true,
                data: data
            };
        } catch (error) {
            console.error('Error fetching post:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Create new blog post
    async createPost(post) {
        try {
            const { data, error } = await supabase
                .from('blog_posts')
                .insert([{
                    slug: post.slug,
                    title: post.title,
                    excerpt: post.excerpt || '',
                    content: post.content,
                    category: post.category || 'Uncategorized',
                    author: post.author || 'Admin',
                    date: post.date || new Date().toISOString().split('T')[0],
                    hero_image: post.heroImage || null,
                    tags: post.tags || []
                }])
                .select()
                .single();

            if (error) throw error;

            return {
                success: true,
                data: data
            };
        } catch (error) {
            console.error('Error creating post:', error);
            return {
                success: false,
                error: error.code === '23505' 
                    ? 'A blog post with this slug already exists' 
                    : error.message
            };
        }
    },

    // Update blog post
    async updatePost(slug, updates) {
        try {
            const { data, error } = await supabase
                .from('blog_posts')
                .update({
                    title: updates.title,
                    excerpt: updates.excerpt,
                    content: updates.content,
                    category: updates.category,
                    author: updates.author,
                    date: updates.date,
                    hero_image: updates.heroImage,
                    tags: updates.tags,
                    updated_at: new Date().toISOString()
                })
                .eq('slug', slug)
                .select()
                .single();

            if (error) throw error;

            return {
                success: true,
                data: data
            };
        } catch (error) {
            console.error('Error updating post:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Delete blog post
    async deletePost(slug) {
        try {
            const { error } = await supabase
                .from('blog_posts')
                .delete()
                .eq('slug', slug);

            if (error) throw error;

            return {
                success: true,
                message: 'Blog post deleted successfully'
            };
        } catch (error) {
            console.error('Error deleting post:', error);
            return {
                success: false,
                error: error.message
            };
        }
    }
};

